import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { filter, distinctUntilChanged, map } from 'rxjs/operators';
import { SessionEventsService } from '../events/session-events.service';

@Injectable({ providedIn: 'root' })
export class AuthRedirectEffect {
    private readonly router = inject(Router);
    private readonly sessionEvents = inject(SessionEventsService);

    constructor() {
        this.sessionEvents.loggedInCheck().pipe(
            map(e => e?.isLoggedIn === true),
            distinctUntilChanged(),
            filter(isLoggedIn => !isLoggedIn),
        ).subscribe(() => {
            if (this.router.url.startsWith('/login')) return;
            this.router.navigate(['/login']);
        });
    }
}